import type { EnrollmentStepSubmissionResponse } from '@/api/enrollment-api'
import { normalizeCurrentStepForUi } from '../../../../utils/enrollmentHydration/status'
import { SELF_ENROLLMENT_STEPS } from '../../utils/steps'

export type StepSubmitSuccessOptions = {
  fallbackNextStep?: number
  forcedNextStep?: number
  onSuccess?: () => void
}

type ResolveStepSubmitSuccessArgs = {
  response: EnrollmentStepSubmissionResponse
  step: number
  options?: StepSubmitSuccessOptions
  suppressNextSessionStepSync: () => void
  goToStep: (step: number) => void
}

export function resolveStepSubmitSuccess({
  response,
  step,
  options,
  suppressNextSessionStepSync,
  goToStep
}: ResolveStepSubmitSuccessArgs) {
  if (response.eligible === false) {
    suppressNextSessionStepSync()
    goToStep(SELF_ENROLLMENT_STEPS.NOT_ELIGIBLE)
    return
  }

  if (typeof options?.forcedNextStep === 'number') {
    const nextStep =
      options.forcedNextStep === SELF_ENROLLMENT_STEPS.SIGN_DOCUMENTS
        ? normalizeCurrentStepForUi(response) ?? options.forcedNextStep
        : options.forcedNextStep

    suppressNextSessionStepSync()
    goToStep(nextStep)
    return
  }

  if (options?.onSuccess) {
    options.onSuccess()
    return
  }

  suppressNextSessionStepSync()
  goToStep(options?.fallbackNextStep ?? step + 1)
}
